// extracted by mini-css-extract-plugin
export default {"arrivalMarker":"xFbVK","arrivalMarkerFlag":"llAZo"};